export default __webpack_public_path__ + "static/with-pencil-fb6472ee4fdd5b7c4f874e8de7b3ba8e.webp";